import getPopularPagePaths from "~backend/prepr/popularPages";
import { locales } from "~config/locale";
import {
  getDynamicPageHandler,
  SERVER_RENDER_METHOD,
} from "~utils/nextjs/pages/dynamicPageHandler";
import withLayout from "~utils/withLayout";

import DynamicPage from "~modules/DynamicPage";

// disabled in development, because it will fetch the popular pages from prepr
// on every (hot) reload
// const prerenderPopularPagesEnabled = true;
const prerenderPopularPagesEnabled = process.env.NODE_ENV !== "development";

export const getStaticPaths = async () => {
  if (process.env.FAST_BUILD === "1") {
    return {
      paths: [],
      fallback: "blocking",
    };
  }

  // get popular pages
  let paths = [];
  if (prerenderPopularPagesEnabled) {
    for (const locale of locales) {
      paths = [...paths, ...(await getPopularPagePaths(locale))];
    }
  }

  return {
    paths,
    fallback: "blocking",
  };
};

export const getStaticProps = getDynamicPageHandler(SERVER_RENDER_METHOD.SSG, {
  revalidate: 60 * 60, // 1 hour
});

export default withLayout(DynamicPage);
